import { IBaseEventArgs } from '../../../models/modal-form-metadata.model';
import { FormEventsModalConfig } from "../../../office-form/events/models/form-events-modal-config.model";

export abstract class IFormEventHandlerFn {
  static handle(config: FormEventsModalConfig): IBaseEventArgs | null {
    throw new Error('handle method must be implemented in a derived class');
  }
}
